module.exports = __webpack_public_path__ + "img/IND-A-3-II.cfc875e9.png";